<template>
    <apex
        width="500"
        type="line"
        :options="optionsFinal"
        :series="series"
    />
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    components: {
        apex: VueApexCharts,
    },
    props: {
        series: Array,
        options: Object,
        id: String,
        categories: Array,
    },
    computed: {
        optionsFinal() {
            const options = this.options;
            return { 
                ...options,
                chart: {
                    id: this.id,
                },
                xaxis: {
                    categories: this.categories,
                }
            };
        }
    },
}
</script>